var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component } from "vue-property-decorator";
import TheHeaderLogo from "./TheHeaderLogo";
import SearchBar from "./TheHeaderSearchBar";
import Search from "./TheHeaderSearchLarge";
import TheHeaderMenuApps from "./TheHeaderMenuApps";
import TheHeaderMenuProfile from "./TheHeaderMenuProfile";
import DialogAuth from "@/components/DialogAuth";
import HTTP from "@/http";
var TheHeader = (function (_super) {
    __extends(TheHeader, _super);
    function TheHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        return _this;
    }
    Object.defineProperty(TheHeader.prototype, "isAuthenticated", {
        get: function () {
            return this.$store.state.user.isAuthenticated;
        },
        enumerable: true,
        configurable: true
    });
    ;
    TheHeader.prototype.demoGetToken = function () {
        var _this = this;
        this.isLoading = true;
        HTTP.get('token').then(function (response) {
            _this.demoLogin(response);
            _this.isLoading = false;
        }, function (response) {
            _this.isLoading = false;
        });
    };
    TheHeader.prototype.demoLogin = function (response) {
        var _this = this;
        var data = {
            client_id: 2,
            client_secret: response.data,
            grant_type: 'password',
            username: "demo@demo.demo",
            password: "demo",
        };
        var axiosConfigUrl = "http://" + window.location.hostname + ":4562/" + "oauth/token";
        if (window.location.hostname === 'myouseek.com') {
            axiosConfigUrl = 'https://api.' + window.location.hostname + "/oauth/token";
        }
        HTTP.post(axiosConfigUrl, data).then(function (response) {
            _this["$auth"].setToken(response.data.access_token, response.data.expires_in + Date.now() + 15 * 24 * 60 * 60 * 1000);
            _this.$router.push("/");
            location.reload();
        }, function (response) {
            _this.isLoading = false;
        });
    };
    TheHeader = __decorate([
        Component({
            components: {
                "search-lg": Search,
                "search": SearchBar,
                "logo": TheHeaderLogo,
                "menu-apps": TheHeaderMenuApps,
                "menu-profile": TheHeaderMenuProfile,
                DialogAuth: DialogAuth,
            },
        })
    ], TheHeader);
    return TheHeader;
}(Vue));
export default TheHeader;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/TheHeader/TheHeader.vue
// module id = 258
// module chunks = 0